import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectNippo } from '../actions'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

class NippoTrendCell extends Component {
  render() {
    const { selectNippo, nippoData, users } = this.props

    return (
      <a className="box" onClick={e => selectNippo(nippoData.postId)}>
        <article className="media">
        <div className="media-content">
          <div className="content">
            <div>
            {
              users
              ? (
                <div>
                  <strong>{users[nippoData.uid].displayName}</strong> <small>@{users[nippoData.uid].slackName}</small> <small>{nippoData.createdAt}</small>
                  <br />
                  <ReactMarkdown
                    source={nippoData.text}
                    plugins={[breaks]}
                  />
                </div>
              )
              : null
            }
            </div>
          </div>
        </div>
        </article>
      </a>
    )
  }
}

export default connect(
  state => ({
    users: state.users
  }),
  { selectNippo }
)(NippoTrendCell)



// WEBPACK FOOTER //
// ./src/components/NippoTrendCell.js